module.exports = __webpack_public_path__ + "img/goalAchievednew.741555b4.png";